import React from 'react';
import { Table, Card, Tabs, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import styles from './Disk.module.scss';

const { TabPane } = Tabs;

const LvmInfo = ({ lvmInfo }) => {
  // LVM 정보 파싱 (PV, VG, LV)
  const parsePvInfo = (data) => {
    if (!data || data === 'N/A') return [];
    
    try {
      const pvs = [];
      const lines = data.trim().split('\n');
      
      // 헤더 라인 건너뛰기
      const dataLines = lines.slice(1);
      
      dataLines.forEach(line => {
        const parts = line.trim().split(/\s+/);
        if (parts.length >= 6) {
          pvs.push({
            pv: parts[0],
            vg: parts[1] || 'N/A',
            format: parts[2],
            attr: parts[3],
            size: parts[4],
            free: parts[5],
            key: parts[0]
          });
        }
      });
      
      return pvs;
    } catch (error) {
      console.error('Error parsing PV info:', error);
      return [];
    }
  };
  
  const parseVgInfo = (data) => {
    if (!data || data === 'N/A') return [];
    
    try {
      const vgs = [];
      const lines = data.trim().split('\n');
      
      // 헤더 라인 건너뛰기
      const dataLines = lines.slice(1);
      
      dataLines.forEach(line => {
        const parts = line.trim().split(/\s+/);
        if (parts.length >= 7) {
          vgs.push({
            vg: parts[0],
            pvs: parts[1],
            lvs: parts[2],
            snapshots: parts[3],
            attr: parts[4],
            size: parts[5],
            free: parts[6],
            key: parts[0]
          });
        }
      });
      
      return vgs;
    } catch (error) {
      console.error('Error parsing VG info:', error);
      return [];
    }
  };
  
  const parseLvInfo = (data) => {
    if (!data || data === 'N/A') return [];
    
    try {
      const lvs = [];
      const lines = data.trim().split('\n');
      
      // 헤더 라인 건너뛰기
      const dataLines = lines.slice(1);
      
      dataLines.forEach(line => {
        const parts = line.trim().split(/\s+/);
        if (parts.length >= 7) {
          lvs.push({
            lv: parts[0],
            vg: parts[1],
            attr: parts[2],
            size: parts[3],
            pool: parts[4] || 'N/A',
            origin: parts[5] || 'N/A',
            data: parts[6] || 'N/A',
            key: `${parts[1]}-${parts[0]}`
          });
        }
      });
      
      return lvs;
    } catch (error) {
      console.error('Error parsing LV info:', error);
      return [];
    }
  };

  const pvs = parsePvInfo(lvmInfo?.pv);
  const vgs = parseVgInfo(lvmInfo?.vg);
  const lvs = parseLvInfo(lvmInfo?.lv);

  return (
    <Card 
      title={
        <div>
          LVM 정보
          <Tooltip title="Logical Volume Manager (LVM) 구성 정보입니다.">
            <InfoCircleOutlined style={{ marginLeft: 8 }} />
          </Tooltip>
        </div>
      } 
      className={styles.diskCard}
    >
      <Tabs defaultActiveKey="pv">
        <TabPane tab="물리 볼륨 (PV)" key="pv">
          <Table 
            dataSource={pvs}
            rowKey="key"
            pagination={false}
            columns={[
              { title: '물리 볼륨', dataIndex: 'pv', key: 'pv' },
              { title: '볼륨 그룹', dataIndex: 'vg', key: 'vg' },
              { title: '포맷', dataIndex: 'format', key: 'format' },
              { title: '속성', dataIndex: 'attr', key: 'attr' },
              { title: '크기', dataIndex: 'size', key: 'size' },
              { title: '여유 공간', dataIndex: 'free', key: 'free' }
            ]}
          />
        </TabPane>
        <TabPane tab="볼륨 그룹 (VG)" key="vg">
          <Table 
            dataSource={vgs}
            rowKey="key"
            pagination={false}
            columns={[
              { title: '볼륨 그룹', dataIndex: 'vg', key: 'vg' },
              { title: 'PV 수', dataIndex: 'pvs', key: 'pvs' },
              { title: 'LV 수', dataIndex: 'lvs', key: 'lvs' },
              { title: '스냅샷 수', dataIndex: 'snapshots', key: 'snapshots' },
              { title: '속성', dataIndex: 'attr', key: 'attr' },
              { title: '크기', dataIndex: 'size', key: 'size' },
              { title: '여유 공간', dataIndex: 'free', key: 'free' }
            ]}
          />
        </TabPane>
        <TabPane tab="논리 볼륨 (LV)" key="lv">
          <Table 
            dataSource={lvs}
            rowKey="key"
            pagination={false}
            columns={[
              { title: '논리 볼륨', dataIndex: 'lv', key: 'lv' },
              { title: '볼륨 그룹', dataIndex: 'vg', key: 'vg' },
              { title: '속성', dataIndex: 'attr', key: 'attr' },
              { title: '크기', dataIndex: 'size', key: 'size' },
              { title: '풀', dataIndex: 'pool', key: 'pool' },
              { title: '원본', dataIndex: 'origin', key: 'origin' },
              { title: '데이터', dataIndex: 'data', key: 'data' }
            ]}
          />
        </TabPane>
      </Tabs>
    </Card>
  );
};

export default LvmInfo;